<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Consulta de órdenes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <!--<v-tooltip right v-if="!showFilters">
             <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="!roles_tecnico.includes(rol)"
                    fab
                    :to="{ path: `/guardar-orden` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
                <div style="display: flex" v-else>
                    <v-btn
                        fab
                        @click="AddOrdenEmpleado"
                        :loading="isloading"
                        :disabled="isloading"
                        color="orange darken-1"
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-account-plus-outline</v-icon
                        >
                    </v-btn>
                    <v-text-field
                        label="Numero de Orden"
                        v-model="nro_orden"
                        style="margin-left: 1rem"
                    >
                    </v-text-field>
                </div>
            </template>
            <span>Nueva Orden de Trabajo</span>
        </v-tooltip> -->
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                    v-model="presupuesto_id"
                    label="Por presupuesto"
                    :items="presupuestos"
                    @change="getOrdenes()"
                ></v-autocomplete>
                <!-- item-text="item.id"
                    item-value="item.id" -->
            </v-col>

            <v-col cols="12" sm="6" md="6">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="cliente"
                    label="Buscar por cliente"
                ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="8"> -->
            <v-col cols="12" sm="6" md="6">
                <date-select
                    label="Finalizada desde"
                    v-model="fecha_inicio"
                ></date-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <date-select
                    label="Finalizada hasta"
                    v-model="fecha_fin"
                ></date-select>
            </v-col>
            <!-- </v-col> -->

            <v-col cols="12" md="4">
                <!-- <v-btn
                    color="primary"
                    class="white--text"
                    @click="
                        () => {
                            page = 1;
                            getOrdenes();
                        }
                    "
                >
                    Filtrar
                </v-btn> -->
                <v-btn
                    color="red"
                    class="white--text"
                    @click="
                        presupuesto_id = null;
                        fecha_inicio = '';
                        fecha_fin = '';
                        cliente = '';
                        getOrdenes();
                    "
                >
                    Limpiar filtros
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Ordenes"
            :items-per-page="15"
            item-key="id"
            class="elevation-1 mt-4"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            @click:row="
                (item) => {
                    OpenOrdenInNextWindow(item);
                }
            "
            :server-items-length="total_orden_trabajo"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.coste_total="{ item }">
                <span>{{
                    (item.total_mano_obra + item.total_materiales)
                        | format_precio
                }}</span>
            </template>
            <template v-slot:item.beneficio="{ item }">
                <!-- Total Ventas - total coste -->
                <span>{{ linea_beneficio(item) | format_precio }}</span>
            </template>
            <template v-slot:item.coste_estructura="{ item }">
                <!-- Total Ventas - total coste -->
                <span>{{ item.coste_estructura | format_precio }}</span>
            </template>
            <template v-slot:item.total_materiales="{ item }">
                <!-- Total Ventas - total coste -->
                <span>{{ item.total_materiales | format_precio }}</span>
            </template>
            <template v-slot:item.total_mano_obra="{ item }">
                <!-- Total Ventas - total coste -->
                <span>{{ item.total_mano_obra | format_precio }}</span>
            </template>
            <template v-slot:item.presupuesto.total="{ item }">
                <!-- Total Ventas - total coste -->
                <span v-if="item.presupuesto">{{
                    item.presupuesto.total | format_precio
                }}</span>
            </template>

            <template v-slot:item.percent_venta="{ item }">
                <!-- beneficio / total_venta * 100 -->
                <span>{{ linea_percent_venta(item) | format_numero }}</span>
            </template>

            <template v-slot:item.percent_coste="{ item }">
                <!-- beneficio / total_coste * 100 -->
                <span>{{ linea_percent_coste(item) | format_numero }}</span>
            </template>
        </v-data-table>
    </v-card>
</template>
<style>
.round {
    border-radius: 10000px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.Back-Yellow {
    background-color: rgb(255, 243, 132);
}
.Back-Green {
    background-color: rgba(158, 255, 158, 0.582);
}
.Back-Orange {
    background-color: rgb(248, 182, 60);
}
.Back-Blue {
    background-color: rgb(93, 173, 248);
}
.Back-Brown {
    background-color: rgba(80, 56, 56, 0.411);
}
</style>
<script>
import FormOrdenConsumo from "./FormOrdenConsumo.vue";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import FormPlan from "./FormPlan.vue";
import moment from "moment";
export default {
    components: {
        FormOrdenConsumo,
        FilterComponentVue,
        FormPlan,
    },
    data() {
        return {
            total_orden_trabajo: 0,
            page: 1,
            cantidad: 15,
            id_orden: null,
            plan_dialog: false,
            dialog_consumo: false,
            cliente: "",
            dialog: false,
            /*
            Nombre cliente - Comercial - Población - Elevación -  Instalación electrica - Prioridad (tenemos que ver) - Tiempo estimado (horas) - Pvp sin Iva - Obseraciones - Descripcoón
            */
            headers: [
                {
                    text: "Cliente",
                    value: "cliente.nombre_comercial",
                    sortable: false,
                },
                { text: "Nº Obra", value: "nro_orden", sortable: false },

                {
                    text: "Coste de mano de obra",
                    value: "total_mano_obra",
                    sortable: false,
                },
                {
                    text: "Coste de material",
                    value: "total_materiales",
                    sortable: false,
                },
                {
                    text: "Coste de estructura",
                    value: "coste_estructura",
                    sortable: false,
                },
                {
                    text: "Coste total",
                    value: "coste_total",
                    sortable: false,
                },
                {
                    text: "Venta",
                    value: "venta",
                    sortable: false,
                },
                { text: "Beneficio", value: "beneficio", sortable: false },
                {
                    text: "% Sobre venta",
                    value: "percent_venta",
                    sortable: false,
                },
                {
                    text: "% Beneficio sobre coste",
                    value: "percent_coste",
                    sortable: false,
                },
            ],
            Ordenes: [],
            dialog: false,
            orden: {},
            presupuestos: {},
            presupuesto_id: null,
            fecha_inicio: "",
            // fecha_inicio: moment().startOf('month').format('YYYY-MM-DD'),
            // fecha_fin: moment().endOf('month').format('YYYY-MM-DD'),
            fecha_fin: "",
        };
    },
    created() {
        this.getOrdenes();
        this.getPresupuestos();
        // this.getTiposOrden();
    },
    methods: {
        linea_percent_coste(item) {
            let dividendo = item.total_mano_obra + item.total_materiales;
            if (dividendo == 0) return "0.00";
            let res =
                (((item.presupuesto?.total ?? 0) -
                    (item.total_mano_obra + item.total_materiales)) /
                    dividendo) *
                100;
            if (isNaN(res)) return 0;
            return res.toFixed(2);
        },
        linea_percent_venta(item) {
            return (
                ((
                    (item.presupuesto?.total ?? 0) -
                    (item.total_mano_obra + item.total_materiales)
                ).toFixed(2) /
                    (item.presupuesto?.total ?? 1)) *
                100
            ).toFixed(2);
        },
        linea_beneficio(item) {
            return (
                (item.presupuesto?.total ?? 0) -
                ((item.total_mano_obra ?? 0) + (item.total_materiales ?? 0))
            ).toFixed(2);
        },
        OpenOrdenInNextWindow(item) {
            //this.$router.push(`/guardar-orden?id=${item.id}`);
            window.open(`/#/guardar-orden?id=${item.id}`, "_blank");
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getOrdenes();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getOrdenes();
        },
        // ColorEstado(item) {
        //     let res = "pointer ";
        //     if (item.id_estado == 2 || item.id_estado == 3) {
        //         res += "Back-Yellow";
        //     } else if (item.id_estado == 4) {
        //         res += "Back-Green";
        //     } else if (item.id_estado == 5) {
        //         res += "Back-Orange";
        //     } else if (item.id_estado == 6) {
        //         res += "Back-Blue";
        //     } else if (item.id_estado == 7) {
        //         res += "Back-Brown";
        //     }
        //     return res;
        // },
        // Fichar(item, detener) {
        //     axios
        //         .post(`api/fichar-orden/${item.id}`, {
        //             detener: detener,
        //         })
        //         .then(
        //             (res) => {
        //                 item.fichajes = res.data.ordenes;
        //                 item.horas_realizadas = res.data.horas;
        //                 item.id_estado = res.data.estado;
        //             },
        //             (res) => {}
        //         );
        // },
        // openDeleteModal(id) {
        //     this.dialog = true;
        //     this.id = id;
        // },
        // AddOrdenEmpleado() {
        //     axios
        //         .post(`api/add-orden-empleado`, { nro_orden: this.nro_orden })
        //         .then(
        //             (res) => {
        //                 this.getOrdenes();
        //             },
        //             (res) => {}
        //         );
        // },
        // deleteOrden() {
        //     axios.get(`api/delete-orden/${this.id}`).then(
        //         (res) => {
        //             this.getOrdenes();
        //             this.dialog = false;
        //         },
        //         (res) => {}
        //     );
        // },
        getOrdenes() {
            this.loading = true;
            // let filtros = this.filterString;
            axios
                .get(
                    `api/consulta-ordenes?page=${this.page}&amount=${this.cantidad}${this.filtros}`
                )
                .then(
                    (res) => {
                        // this.Ordenes = res.data;
                        this.Ordenes = res.data.data;
                        this.total_orden_trabajo = res.data.total;
                        //this.filter_headers[0].items = res.data.data;

                        console.log("Ordenes", this.Ordenes);
                    },
                    (err) => {
                        this.$custom_error("Error consultando las órdenes");
                    }
                );
        },
        getPresupuestos() {
            axios.get(`api/get-presupuestos`).then(
                (res) => {
                    console.log(res);
                    this.presupuestos = res.data.Presupuestos;
                },
                (res) => {}
            );
        },
        // openModal(item) {
        //     this.selectedItem = this.Ordenes.indexOf(item);
        //     this.dialog = true;
        // },
        // deleteUser() {
        //     axios
        //         .post("api/delete-orden", {
        //             id: this.Ordenes[this.selectedItem].id,
        //         })
        //         .then(
        //             (res) => {
        //                 this.$toast.sucs("orden eliminado");
        //                 this.dialog = false;
        //                 this.getOrdenes();
        //             },
        //             (err) => {
        //                 this.$custom_error("Error eliminando orden");
        //             }
        //         );
        // },
    },
    computed: {
        rol: function () {
            let rol = localStorage.getItem("role");
            console.log(rol);
            return rol;
        },
        isloading: function () {
            // return this.$store.getters.getloading
        },
        filtros() {
            let str = "";
            const consult = [
                { key: "fecha_inicio", value: this.fecha_inicio },
                { key: "fecha_fin", value: this.fecha_fin },
                { key: "cliente", value: this.cliente },
                { key: "presupuesto_id", value: this.presupuesto_id },
            ];
            consult.forEach((ele) => {
                if (ele.value != null && ele.value != "") {
                    str += `&${ele.key}=${ele.value}`;
                }
            });

            return str;
        },

        // filterString() {
        //     let filtros = "";

        //     if (
        //         this.filtros_prueba.search != null &&
        //         this.filtros_prueba.search != ""
        //     ) {
        //         filtros += `&busqueda=${this.filtros_prueba.search}`;
        //     }

        //     this.filter_headers.forEach((head) => {
        //         if (this.filtros_prueba[head.model]) {
        //             if (
        //                 (this.filtros_prueba[head.model].value != "" &&
        //                     this.filtros_prueba[head.model].value != null) ||
        //                 (this.filtros_prueba[head.model].nombre != "" &&
        //                     this.filtros_prueba[head.model].nombre != null)
        //             ) {
        //                 filtros += `&${head.model}=${
        //                     this.filtros_prueba[head.model].value
        //                 }`;
        //             }
        //         }
        //     });
        //     if (this.id_presupuesto) {
        //         filtros += `&id_presupuesto=${this.id_presupuesto}`;
        //     }
        //     return filtros;
        // },
    },
    watch: {
        fecha_inicio: {
            deep: true,
            handler: function (val) {
                this.getOrdenes();
            },
        },
        fecha_fin: {
            deep: true,
            handler: function (val) {
                this.getOrdenes();
            },
        },
        cliente: {
            handler: function (val) {
                this.getOrdenes();
            },
        },
    },
};
</script>
